"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserPanelInput = exports.UserPanelModal = void 0;
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
exports.UserPanelModal = (0, app_1.styled)(ui_1.Modal) `
  max-width: 47rem;
  * {
    font-family: 'DM Sans', sans-serif;
  }
  label {
    cursor: text;
    color: ${(theme) => theme.colors.gray.semilight};
    z-index: 1;
    font-size: 1rem;
    margin-left: 0.75rem;
    user-select: none;
    position: absolute;
    top: 0.0625rem;
    bottom: 0.0625rem;
    left: ${(theme) => theme.spacing.small};
    display: flex;
    align-items: center;
    padding: 0.15rem;
    transition: 150ms all;
    font-size: 1.0625rem;
    color: ${(theme) => theme.colors.gray};
    margin: 0;
    &.focus-visible,
    &.with-value {
      top: -0.625rem;
      bottom: unset;
      left: 0.5rem;
      font-size: 0.8125rem;
      padding: 0 0.25rem;
      background-color: white;
    }
    ${app_1.styled.disabled `
      opacity: 0.3;
    `}
  }
`;
exports.UserPanelInput = (0, app_1.styled)(ui_1.TextInput) `
  height: 3.5rem;
  border: 1px solid ${(theme) => theme.stroke};
  border-radius: ${(theme) => theme.radius.small};
  ${app_1.styled.focus `
    border: 1px solid ${(theme) => theme.stroke};
    border-color: ${(theme) => theme.stroke};
    box-shadow: 0px 0px 0px 0.1px ${(theme) => theme.stroke};
  `}
  ${app_1.styled.disabled `
    opacity: 0.3;
  `}
`;
